import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnDestroy, ViewContainerRef } from '@angular/core';
import { PetlService } from '../../../services/petl.service';
import { PetlBaseComponent } from '../petl-base.component';
var PetlColumnMappingComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PetlColumnMappingComponent, _super);
    function PetlColumnMappingComponent(_vcr, petlService, cdr) {
        var _this = _super.call(this, _vcr, petlService, cdr) || this;
        _this.petlService = petlService;
        _this.cdr = cdr;
        _this.geometryType = null;
        _this.draggedDatabaseField = null;
        _this.draggedColumn = null;
        _this.geometryIsValid = function () {
            return _this.geometryType && _this.geometryType !== 'Unknown';
        };
        _this.initialize = function () {
            _this.draggedDatabaseField = null;
            _this.draggedColumn = null;
            _this.initializeStandardFieldsForHelp();
        };
        _this.refresh = function () {
            _this.refreshColumnMapping();
        };
        _this.refreshColumnMapping();
        _this.fileUploadedSubscription = _this.petlService.fileUploaded.subscribe(function () {
            _this.refreshColumnMapping();
        });
        return _this;
    }
    PetlColumnMappingComponent.prototype.ngOnDestroy = function () {
        this.fileUploadedSubscription.unsubscribe();
    };
    Object.defineProperty(PetlColumnMappingComponent.prototype, "allColumnsMapped", {
        get: function () {
            return this.petlService.columnData && this.getNumberOfColumnsMapped() === this.petlService.columnData.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlColumnMappingComponent.prototype, "databaseFieldsNotCustom", {
        get: function () {
            var results = this.filterColumns(this.petlService.results.unusedDatabaseFields || [], 'customField', false);
            results = this.filterColumns(results, 'hidden', false);
            return results;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlColumnMappingComponent.prototype, "databaseFieldsCustom", {
        get: function () {
            var _this = this;
            var e_1, _a;
            var results = this.filterColumns(this.petlService.results.unusedDatabaseFields || [], 'customField', true);
            results = this.filterColumns(results, 'hidden', false);
            results = results.sort(function (a, b) { return _this.customFieldComparator(a, b); });
            var filteredResults = [];
            var limit = 1; // Only display 1 of eFach unused custom field type
            var counts = new Array(this.petlService.customTypes.length).fill(0);
            try {
                for (var results_1 = tslib_1.__values(results), results_1_1 = results_1.next(); !results_1_1.done; results_1_1 = results_1.next()) {
                    var result = results_1_1.value;
                    var prefix = result.databaseName.split('_')[0];
                    var index = this.petlService.customTypes.indexOf(prefix);
                    var count = counts[index]++;
                    if (count < limit) {
                        if (result.displayName.match(/\d/)) {
                            result.displayName = result.displayName.split(' ').slice(0, -1).join(' ');
                        }
                        filteredResults.push(result);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (results_1_1 && !results_1_1.done && (_a = results_1.return)) _a.call(results_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return filteredResults;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlColumnMappingComponent.prototype, "noColumnsMapped", {
        get: function () {
            return this.getNumberOfColumnsMapped() === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlColumnMappingComponent.prototype, "sheetsForSelect", {
        get: function () {
            return this.populateArray(this.petlService.sheetCount, 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlColumnMappingComponent.prototype, "geometryClass", {
        get: function () {
            if (this.geometryIsValid()) {
                return 'label-success';
            }
            else {
                return 'label-danger';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlColumnMappingComponent.prototype, "service", {
        get: function () {
            return this.petlService;
        },
        enumerable: true,
        configurable: true
    });
    PetlColumnMappingComponent.prototype.clearPreviousMappingAndResetColumnMapping = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.petlService.showRepeatFileNameIndicator = false;
                        this.petlService.ignorePreviousColumnMappings = true;
                        return [4 /*yield*/, this.resetAutomatedColumnMapping()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PetlColumnMappingComponent.prototype.resetAutomatedColumnMapping = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.removeAllMappedFields();
                        return [4 /*yield*/, this.petlService.resetAutomatedColumnMapping()];
                    case 1:
                        _a.sent();
                        this.refreshColumnMapping();
                        return [2 /*return*/];
                }
            });
        });
    };
    PetlColumnMappingComponent.prototype.redefineStartingRowNumber = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.redefineStartingRowNumber()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PetlColumnMappingComponent.prototype.initializeStandardFieldsForHelp = function () {
        var twoChar = 2;
        var fourChar = 4;
        this.standardFields = [];
        this.addStandardField('County', twoChar);
        this.addStandardField('SR', fourChar);
        this.addStandardField('Seg Begin', fourChar);
        this.addStandardField('Seg End', fourChar);
        this.addStandardField('Jurisdiction', 1);
        this.addStandardField('Offset Begin');
        this.addStandardField('Offset End');
        this.addStandardField('Seg Length');
        this.addStandardField('Lat');
        this.addStandardField('Long');
        this.addStandardField('BRKey');
        this.addStandardField('Bridge Id');
        this.addStandardField('MPMS Number');
    };
    PetlColumnMappingComponent.prototype.addStandardField = function (name, maxlength) {
        if (maxlength === void 0) { maxlength = null; }
        var standardField = {};
        standardField.displayName = name;
        if (maxlength) {
            standardField.maxLength = maxlength;
        }
        this.standardFields.push(standardField);
        this.standardFields.push();
    };
    PetlColumnMappingComponent.prototype.columnMappingClick = function (ev) {
        if (!ev.path || !ev.path.indexOf('edit-alias')) {
            this.closeEditMode();
        }
    };
    PetlColumnMappingComponent.prototype.dataItemClick = function (ev, dataItem) {
        ev.stopPropagation();
        if (this.dataItemInEditMode && this.dataItemInEditMode !== dataItem) {
            this.dataItemInEditMode.editMode = false;
        }
        this.dataItemInEditMode = dataItem;
        this.dataItemInEditMode.editMode = true;
    };
    PetlColumnMappingComponent.prototype.inputBlur = function () {
        this.closeEditMode();
    };
    PetlColumnMappingComponent.prototype.closeEditMode = function () {
        if (this.dataItemInEditMode) {
            this.dataItemInEditMode.editMode = false;
            this.dataItemInEditMode.displayName = this.getDragElementDisplayValue(this.dataItemInEditMode);
            this.dataItemInEditMode = null;
        }
    };
    PetlColumnMappingComponent.prototype.getDatabaseFieldClass = function (databaseField) {
        if (databaseField.customField) {
            return 'alert-info';
        }
        else {
            return 'alert-success';
        }
    };
    PetlColumnMappingComponent.prototype.getColumnClass = function (data) {
        if (data.databaseField) {
            return this.getDatabaseFieldClass(data.databaseField);
        }
        return 'empty';
    };
    PetlColumnMappingComponent.prototype.getColumnElementByIndex = function (index) {
        return this.petlService.columnData.filter(function (x) { return x.index === index; })[0];
    };
    PetlColumnMappingComponent.prototype.getIndexOfDatabaseFieldInUnusedList = function (propertyName) {
        return this.petlService.results.unusedDatabaseFields.map(function (x) { return x.propertyName; }).indexOf(propertyName);
    };
    PetlColumnMappingComponent.prototype.setDraggedDatabaseField = function (databaseField, columnDataElement) {
        this.draggedDatabaseField = databaseField;
        this.draggedColumn = columnDataElement;
    };
    PetlColumnMappingComponent.prototype.getDraggedDatabaseField = function () {
        return this.draggedDatabaseField;
    };
    PetlColumnMappingComponent.prototype.setColumnDataElementDroppedOn = function (columnDataElementDroppedOn) {
        this.petlService.mappingsFromServerAltered = true;
        var columnDroppedOn = this.getColumnElementByIndex(columnDataElementDroppedOn.index);
        if (this.draggedColumn && columnDroppedOn && this.draggedColumn.index === columnDroppedOn.index) {
            return; // do nothing, dropped onto itself
        }
        if (columnDroppedOn.databaseField && columnDroppedOn.databaseField.propertyName !== this.draggedDatabaseField.propertyName) {
            var droppedOnDatabaseField = columnDroppedOn.databaseField;
            columnDroppedOn.databaseField = this.draggedDatabaseField;
            this.moveDatabaseFieldToUnusedList(droppedOnDatabaseField);
        }
        else if (!columnDroppedOn.databaseField) {
            // Field was dragged to a column that was not mapped
            columnDroppedOn.databaseField = this.draggedDatabaseField;
        }
        if (columnDroppedOn.databaseField && columnDroppedOn.databaseField.customField && columnDataElementDroppedOn.nativeHeader) {
            columnDroppedOn.databaseField.aliasName = columnDataElementDroppedOn.nativeHeader;
        }
        if (this.draggedColumn) {
            // A mapped field was dragged from one column to another column
            this.clearDraggedColumn();
        }
        else {
            // Database field was from the unused list, remove the database field dropped from the unused list
            this.removeDatabaseFieldFromUnusedList(this.draggedDatabaseField);
        }
        this.refreshColumnMapping();
    };
    PetlColumnMappingComponent.prototype.setGeometryType = function () {
        if (!this.petlService.columnMapping) {
            this.geometryType = null;
            return;
        }
        if (this.isLine()) {
            this.geometryType = 'Line';
        }
        else if (this.isPoint()) {
            this.geometryType = 'Point';
        }
        else if (this.isBridge()) {
            this.geometryType = 'Bridge';
        }
        else if (this.isMpms()) {
            this.geometryType = 'MPMS';
        }
        else {
            this.geometryType = 'Unknown';
        }
    };
    PetlColumnMappingComponent.prototype.removeDatabaseFieldFromUnusedList = function (databaseField) {
        var databaseFieldIndex = this.getIndexOfDatabaseFieldInUnusedList(databaseField.propertyName);
        this.petlService.results.unusedDatabaseFields.splice(databaseFieldIndex, 1);
        this.updateHiddenFields();
    };
    PetlColumnMappingComponent.prototype.moveDatabaseFieldToUnusedList = function (databaseField) {
        if (!databaseField) {
            databaseField = this.draggedDatabaseField;
        }
        if (databaseField && this.getIndexOfDatabaseFieldInUnusedList(databaseField.propertyName) === -1) {
            databaseField.aliasName = null;
            this.petlService.results.unusedDatabaseFields.push(databaseField);
            this.updateHiddenFields();
            // Sort the unused list by databaseName
            this.sortUnusedDatabaseFields();
        }
        this.clearDraggedColumn();
        this.refreshColumnMapping();
    };
    PetlColumnMappingComponent.prototype.updateHiddenFields = function () {
        var e_2, _a, e_3, _b;
        try {
            for (var _c = tslib_1.__values(this.petlService.columnData), _d = _c.next(); !_d.done; _d = _c.next()) {
                var column = _d.value;
                if (column.databaseField && column.databaseField.hidesOtherField) {
                    this.removeFieldFromMapping(column.databaseField.hidesOtherField);
                    this.toggleUnusedField(column.databaseField.hidesOtherField, true);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
        try {
            for (var _e = tslib_1.__values(this.petlService.results.unusedDatabaseFields), _f = _e.next(); !_f.done; _f = _e.next()) {
                var unusedField = _f.value;
                if (unusedField.hidesOtherField) {
                    this.toggleUnusedField(unusedField.hidesOtherField, false);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    PetlColumnMappingComponent.prototype.refreshColumnMapping = function () {
        if (this.petlService.columnData) {
            this.resetColumnMapping();
            this.setNewColumnMapping();
            this.updateHiddenFields();
            this.setGeometryType();
            this.setDraggedDisplayNames();
        }
    };
    PetlColumnMappingComponent.prototype.removeFieldFromMapping = function (propertyName) {
        var e_4, _a;
        try {
            for (var _b = tslib_1.__values(this.petlService.columnData), _c = _b.next(); !_c.done; _c = _b.next()) {
                var column = _c.value;
                if (column.databaseField && column.databaseField.propertyName === propertyName) {
                    column.databaseField.aliasName = null;
                    this.petlService.results.unusedDatabaseFields.push(column.databaseField);
                    column.databaseField = null;
                    return true;
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return false;
    };
    PetlColumnMappingComponent.prototype.toggleUnusedField = function (propertyName, hide) {
        var e_5, _a;
        try {
            for (var _b = tslib_1.__values(this.petlService.results.unusedDatabaseFields), _c = _b.next(); !_c.done; _c = _b.next()) {
                var unusedField = _c.value;
                if (unusedField.propertyName === propertyName) {
                    unusedField.hidden = hide;
                    return true;
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return false;
    };
    PetlColumnMappingComponent.prototype.sortUnusedDatabaseFields = function () {
        this.petlService.results.unusedDatabaseFields.sort(function (a, b) {
            if (!a.customField && a.customField !== null && a.customField !== b.customField) {
                {
                    return -1;
                }
            }
            else if (a.customField && a.customField !== b.customField) {
                return 1;
            }
            else if (a.databaseName < b.databaseName) {
                return -1;
            }
            else if (a.databaseName > b.databaseName) {
                return 1;
            }
            return 0;
        });
    };
    PetlColumnMappingComponent.prototype.clearDraggedColumn = function () {
        if (this.draggedColumn) {
            var sourceColumn = this.getColumnElementByIndex(this.draggedColumn.index);
            sourceColumn.databaseField = null;
        }
    };
    PetlColumnMappingComponent.prototype.resetColumnMapping = function () {
        var e_6, _a;
        try {
            for (var _b = tslib_1.__values(Object.keys(this.petlService.columnMapping)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                this.petlService.columnMapping[key] = null;
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_6) throw e_6.error; }
        }
    };
    PetlColumnMappingComponent.prototype.setNewColumnMapping = function () {
        var _this = this;
        this.petlService.columnData.forEach(function (column, i) {
            if (column.databaseField) {
                var databaseField = column.databaseField;
                _this.petlService.columnMapping[databaseField.javaScriptPropertyName] = i;
            }
        });
    };
    PetlColumnMappingComponent.prototype.setDraggedDisplayNames = function () {
        var e_7, _a;
        try {
            for (var _b = tslib_1.__values(this.petlService.columnData), _c = _b.next(); !_c.done; _c = _b.next()) {
                var columnData = _c.value;
                columnData.displayName = this.getDragElementDisplayValue(columnData);
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_7) throw e_7.error; }
        }
    };
    PetlColumnMappingComponent.prototype.isPoint = function () {
        var pointProperties = ['county', 'stateRoute', 'segmentBegin', 'offsetBegin'];
        var xAndyProperties = ['xValue', 'yValue'];
        return !this.mappingHasValue('segmentLength') && (this.mappingHasAllProperties(pointProperties) || this.mappingHasAllProperties(xAndyProperties));
    };
    PetlColumnMappingComponent.prototype.isLine = function () {
        var lineProperties = ['county', 'stateRoute', 'segmentBegin'];
        var functionLocationLineProperties = ['functionalLocation', 'segmentBegin'];
        var orgLineProperties = ['orgCode', 'stateRoute', 'segmentBegin'];
        if ((this.mappingHasAllProperties(lineProperties) || this.mappingHasAllProperties(functionLocationLineProperties) || this.mappingHasAllProperties(orgLineProperties))
            && !(this.mappingHasValue('offsetBegin') && !this.mappingHasValue('segmentEnd') && !this.mappingHasValue('offsetEnd'))
            && !(this.mappingHasValue('segmentLength') && (this.mappingHasValue('segmentEnd') || this.mappingHasValue('offsetEnd')))) {
            return true;
        }
        return false;
    };
    PetlColumnMappingComponent.prototype.isMpms = function () {
        return this.mappingHasValue('mpmsNumber');
    };
    PetlColumnMappingComponent.prototype.isBridge = function () {
        return this.mappingHasValue('brKey') || this.mappingHasValue('bridgeId');
    };
    PetlColumnMappingComponent.prototype.mappingHasAllProperties = function (properties) {
        var e_8, _a;
        var allFound = true;
        try {
            for (var properties_1 = tslib_1.__values(properties), properties_1_1 = properties_1.next(); !properties_1_1.done; properties_1_1 = properties_1.next()) {
                var property = properties_1_1.value;
                allFound = allFound && this.mappingHasValue(property);
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (properties_1_1 && !properties_1_1.done && (_a = properties_1.return)) _a.call(properties_1);
            }
            finally { if (e_8) throw e_8.error; }
        }
        return allFound;
    };
    PetlColumnMappingComponent.prototype.mappingHasValue = function (property) {
        return this.hasVal(this.petlService.columnMapping[property]);
    };
    PetlColumnMappingComponent.prototype.hasVal = function (val) {
        return val === 0 || val > 0;
    };
    PetlColumnMappingComponent.prototype.removeMappedField = function (colItem, dontRefresh) {
        if (colItem) {
            if (colItem.databaseField) {
                this.moveDatabaseFieldToUnusedList(colItem.databaseField);
            }
            colItem.databaseField = null;
            this.petlService.mappingsFromServerAltered = true;
        }
        if (!dontRefresh) {
            this.refreshColumnMapping();
        }
    };
    PetlColumnMappingComponent.prototype.removeAllMappings = function () {
        this.removeAllMappedFields();
        this.refreshColumnMapping();
    };
    PetlColumnMappingComponent.prototype.removeAllMappedFields = function () {
        var _this = this;
        this.petlService.mappingsFromServerAltered = true;
        this.petlService.columnData.forEach(function (colItem) {
            _this.removeMappedField(colItem, true);
        });
    };
    PetlColumnMappingComponent.prototype.atLeastOneColumnIsMapped = function () {
        if (!this.petlService.columnData) {
            return false;
        }
        var columnMappedFound = false;
        this.petlService.columnData.forEach(function (columnDataValue) {
            if (columnDataValue.databaseField) {
                columnMappedFound = true;
            }
        });
        return columnMappedFound;
    };
    PetlColumnMappingComponent.prototype.getNumberOfColumnsMapped = function () {
        if (!this.petlService.columnData) {
            return 0;
        }
        var numberOfColumnsMapped = 0;
        this.petlService.columnData.forEach(function (columnDataValue) {
            if (columnDataValue.databaseField) {
                numberOfColumnsMapped++;
            }
        });
        return numberOfColumnsMapped;
    };
    PetlColumnMappingComponent.prototype.automapCustomFields = function () {
        var _this = this;
        this.petlService.mappingsFromServerAltered = true;
        this.petlService.columnData.forEach(function (columnDataValue) {
            var autoAssignedDatabaseField = null;
            if (!columnDataValue.databaseField) {
                var dataType = _this.calculateColumnDataType(columnDataValue);
                var dataTypeCustomFields = _this.getCustomUnusedFields(dataType);
                if (dataTypeCustomFields.length > 0) {
                    autoAssignedDatabaseField = dataTypeCustomFields[0];
                }
                else {
                    var charCustomFields = _this.getCustomUnusedFields('char');
                    if (charCustomFields.length > 0) {
                        autoAssignedDatabaseField = charCustomFields[0];
                    }
                }
                if (autoAssignedDatabaseField) {
                    columnDataValue.databaseField = autoAssignedDatabaseField;
                    if (columnDataValue.nativeHeader && _this.petlService.restrictedAliases.indexOf(columnDataValue.nativeHeader) < 0) {
                        columnDataValue.databaseField.aliasName = columnDataValue.nativeHeader;
                    }
                    _this.removeDatabaseFieldFromUnusedList(autoAssignedDatabaseField);
                }
            }
        });
        this.petlService.columnData = [].concat(this.petlService.columnData);
        this.refreshColumnMapping();
    };
    PetlColumnMappingComponent.prototype.isNumeric = function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    };
    PetlColumnMappingComponent.prototype.calculateColumnDataType = function (value) {
        var _this = this;
        var numbersFound = 0;
        var datesFound = 0;
        var urlsFound = 0;
        var blanksFound = 0;
        var thresholdPercentage = 75;
        var oneHundred = 100;
        var sampleCount = this.petlService.fileSample.length;
        this.petlService.fileSample.forEach(function (row) {
            var cell = row[value.index];
            if (!cell) {
                blanksFound++;
            }
            else if (_this.isNumeric(cell)) {
                numbersFound++;
            }
            else if (Date.parse(cell)) {
                datesFound++;
            }
            else if (cell.indexOf(':/') > 0 || cell.indexOf('http') === 0 || cell.indexOf('www.') === 0) {
                urlsFound++;
            }
        });
        if (numbersFound > 0 && (numbersFound * oneHundred / (sampleCount - blanksFound)) >= thresholdPercentage) {
            return 'num';
        }
        else if (datesFound > 0 && (datesFound * oneHundred / (sampleCount - blanksFound)) >= thresholdPercentage) {
            return 'date';
        }
        else if (urlsFound > 0 && (urlsFound * oneHundred / (sampleCount - blanksFound)) >= thresholdPercentage) {
            return 'url';
        }
        return 'char';
    };
    PetlColumnMappingComponent.prototype.getCustomUnusedFields = function (dataType) {
        var customFields = this.petlService.results.unusedDatabaseFields.filter(function (el) {
            return el.customField && el.databaseName.indexOf(dataType.toString() + "_") === 0;
        });
        customFields.sort(function (x, y) {
            var indexOfNumberComponent = 2;
            x = parseInt(x.databaseName.split('_')[indexOfNumberComponent], 10);
            y = parseInt(y.databaseName.split('_')[indexOfNumberComponent], 10);
            if (x < y) {
                return -1;
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });
        return customFields;
    };
    PetlColumnMappingComponent.prototype.filterColumns = function (items, filterProperty, filterValue) {
        var e_9, _a;
        var retVal = [];
        try {
            for (var items_1 = tslib_1.__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                var item = items_1_1.value;
                if (item[filterProperty] === undefined || item[filterProperty] === filterValue) {
                    retVal.push(item);
                }
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
            }
            finally { if (e_9) throw e_9.error; }
        }
        return retVal;
    };
    PetlColumnMappingComponent.prototype.customFieldComparator = function (a, b) {
        var aVal = a.databaseName, bVal = b.databaseName, aNameIndex = this.nameOrderIndex(aVal), bNameIndex = this.nameOrderIndex(bVal);
        if (aNameIndex !== bNameIndex) {
            return (aNameIndex < bNameIndex) ? -1 : 1;
        }
        var aParts = aVal.split('_'), bParts = bVal.split('_'), aNum = aParts.length > 1 ? parseInt(aParts[aParts.length - 1], 10) : -1, bNum = bParts.length > 1 ? parseInt(bParts[bParts.length - 1], 10) : -1;
        if (isNaN(aNum) || isNaN(bNum)) {
            return !isNaN(aNum) ? -1 : 1;
        }
        return aNum === bNum ? 0 : (aNum < bNum ? -1 : 1);
    };
    PetlColumnMappingComponent.prototype.nameOrderIndex = function (displayName) {
        var e_10, _a;
        try {
            for (var _b = tslib_1.__values(this.petlService.customTypes.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = tslib_1.__read(_c.value, 2), i = _d[0], value = _d[1];
                var index = displayName.trim().toLowerCase().indexOf(value);
                if (index === 0) {
                    return i;
                }
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_10) throw e_10.error; }
        }
        return this.petlService.customTypes.length;
    };
    PetlColumnMappingComponent.prototype.populateArray = function (max, base) {
        var retVal = [];
        base = base || 0;
        for (var i = base; i <= max; i++) {
            retVal.push(i);
        }
        return retVal;
    };
    PetlColumnMappingComponent.prototype.getDragElementDisplayValue = function (columnData) {
        if (columnData.databaseField) {
            var databaseField = columnData.databaseField;
            if (databaseField.aliasName) {
                return databaseField.aliasName;
            }
            else {
                return databaseField.displayName;
            }
        }
        return '';
    };
    PetlColumnMappingComponent.prototype.dragOver = function (ev, dataitem) {
        ev.preventDefault();
        if (dataitem) {
            if (this.draggedDatabaseField && this.draggedDatabaseField.customField) {
                dataitem.dragOverCustom = true;
            }
            else {
                dataitem.dragOver = true;
            }
        }
    };
    PetlColumnMappingComponent.prototype.dragLeave = function (dataitem) {
        dataitem.dragOverCustom = false;
        dataitem.dragOver = false;
    };
    PetlColumnMappingComponent.prototype.allowDrop = function (ev) {
        ev.preventDefault();
    };
    PetlColumnMappingComponent.prototype.drag = function (ev) {
        ev.dataTransfer.setData('ID', ev.target.id);
    };
    PetlColumnMappingComponent.prototype.drop = function (dataitem) {
        if (dataitem) {
            if (this.draggedDatabaseField) {
                if (dataitem.databaseField) {
                    this.moveDatabaseFieldToUnusedList(dataitem.databaseField);
                }
                dataitem.databaseField = this.draggedDatabaseField;
                this.setColumnDataElementDroppedOn(dataitem);
            }
            dataitem.dragOverCustom = false;
            dataitem.dragOver = false;
        }
        this.cdr.detectChanges();
    };
    PetlColumnMappingComponent.prototype.unusedDrop = function () {
        this.moveDatabaseFieldToUnusedList(this.draggedDatabaseField);
    };
    PetlColumnMappingComponent.prototype.dragStart = function (dataitem) {
        this.setDraggedDatabaseField(dataitem.databaseField, dataitem);
    };
    PetlColumnMappingComponent.prototype.unusedDragStart = function (databaseField) {
        this.setDraggedDatabaseField(databaseField, null);
    };
    PetlColumnMappingComponent.prototype.dragEnd = function () {
        var _this = this;
        var timeout = 100;
        setTimeout(function () {
            _this.setDraggedDatabaseField(null, null);
        }, timeout);
    };
    return PetlColumnMappingComponent;
}(PetlBaseComponent));
export { PetlColumnMappingComponent };
